import { render, staticRenderFns } from "./APIReport1.vue?vue&type=template&id=7f5c4bd6&scoped=true"
import script from "./APIReport1.vue?vue&type=script&lang=js"
export * from "./APIReport1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5c4bd6",
  null
  
)

export default component.exports